import {
  IBalanceDetail,
  IBalanceSheetItem,
  IClient,
  IDebtorItem,
  IFilterTracking,
  ISemaphoreValue,
} from '../../interfaces/dtos';
import {
  IListOption,
  IProduct,
  ICategory,
  IPortfolioFilter,
  IClientCity,
  IClientTerritory,
} from '../commons/interfaces';

/**
 *
 */
export interface IState {
  errors: any[];
  clients: IClient[] | null;
  clientTerritories: IClientTerritory[];
  customerTypes: IListOption[];
  clientCities: IClientCity[];
  clientCategories: ICategory[];
  customerPaymentOptions: IListOption[];
  clientProductList: IProduct[] | null;
  balanceSheet: IBalanceSheetItem | null;
  balances: IBalanceDetail[] | null;
  debtors: IDebtorItem[] | null;
  clientPortfolioFilter: IPortfolioFilter | null;
  semaphoreItems: ISemaphoreValue[] | null;
  filterTracking: IFilterTracking | null;
}

/**
 *
 */
export interface IContext extends IState {
  fetchClientProducts: () => Promise<boolean>;
  fetchBalanceSheet: (filter?: IPortfolioFilter | null) => Promise<boolean>;
  fetchResources: () => Promise<boolean>;
  fetchSemaphoreItems: (filter?: IPortfolioFilter | null) => Promise<boolean>;
  fetchDebtorList: (
    key: string,
    filter?: IPortfolioFilter | null,
  ) => Promise<boolean>;
  setClientPortfolioFilter: (filter: IPortfolioFilter | null) => void;
  setFilterTracking: (filter: IFilterTracking) => void;
  actions?: typeof ACTION_VERBS;
}

/**
 *
 */
export const ACTION_VERBS = {
  BALANCE_SHEET_SALESMAN: 'BALANCE_SHEET_SALESMAN',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  STATE_PROCESS_ERROR: 'STATE_PROCESS_ERROR',
  GET_SALESMAN_PRODUCTS: 'GET_SALESMAN_PRODUCTS',
  FETCH_BALANCE_CLIENT: 'FETCH_BALANCE_CLIENT',
  BALANCE_SHEET: 'BALANCE_SHEET',
  SALESMAN_RESOURCES: 'SALESMAN_RESOURCES',
  SEMAPHORE_ITEMS: 'SEMAPHORE_ITEMS',
  SET_PORTFOLIO_FILTER: 'SET_PORTFOLIO_FILTER',
  SET_FILTER_TRACKING: 'SET_FILTER_TRACKING',
  DEBTOR_LIST: 'DEBTOR_LIST',
};
